import React from 'react';
import { MobileRowExpandableContent, MobileRowMainContent } from './MobileRowContent';
import { Category } from '../../helpers/types';
import MobileRow from '../../sharedComponents/MobileRow';

interface MobileRowProps {
  data: Category;
}

interface DataWithId extends Category {
  Id: number;
}

const renderMainContent = (data: DataWithId) => <MobileRowMainContent data={data} />;
const renderExpandableContent = (data: DataWithId) => <MobileRowExpandableContent data={data} />;

const CategoriesMobileRow = ({ data }: MobileRowProps) => {
  const dataWithId: DataWithId = {
    ...data,
    Id: data.id,
  };

  return (
    <MobileRow
      data={dataWithId}
      mainContent={renderMainContent}
      expandableContent={renderExpandableContent}
      hasExpandableContent={false}
    />
  );
};

export default CategoriesMobileRow;
